<template>
  <div class="Data-continer">
    <Detail :data="data" ></Detail>
  </div>
</template>

<script>
import Detail from '@/components/detail.vue'
export default {

components:{Detail}
,
created(){

// console.log(this.$route,'query');

},
data(){
  return{
    type:0,
    data:this.$route.query
  }
}
}
</script>

<style scoped>

</style>